@if (programs) {
  <journey-header></journey-header>
  <router-outlet></router-outlet>
  <journey-footer></journey-footer>
} @else {
  @if (!programs) {
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  }
}
